export const appTranslations = {
  en: () =>
    import(/* webpackPrefetch: true */ './en.json').then(translations => ({
      en: translations.default,
    })),
  de: () => import('./de.json').then(translations => ({ de: translations.default })),
  fr: () => import('./fr.json').then(translations => ({ fr: translations.default })),
  nl: () => import('./nl.json').then(translations => ({ nl: translations.default })),
};

export const wysiwygTranslations = {
  /* webpackPrefetch: true */
  /* webpackChunkName: "en-json" */
  en: () => import('@recruitee/prosemirror/locales/src/en.json').then(t => ({ en: t.default })),
  /* webpackChunkName: "de-json" */
  de: () => import('@recruitee/prosemirror/locales/src/de.json').then(t => ({ de: t.default })),
  /* webpackChunkName: "fr-json" */
  fr: () => import('@recruitee/prosemirror/locales/src/fr.json').then(t => ({ fr: t.default })),
  /* webpackChunkName: "nl-json" */
  nl: () => import('@recruitee/prosemirror/locales/src/nl.json').then(t => ({ nl: t.default })),
};
